import React from "react";
import "./Spinner.css";

const Spinner = ({ style }) => {
  return (
    <div className="spinner-container">
      <div className="spinner" style={style}></div>
    </div>
  );
};

export default Spinner;
